@if(contentIsMarkup) {
<div class="modal-body" [innerHTML]="content"></div>
} @else {
<div class="modal-body">
    @if(messages.length > 0) {
    <rask-message-panel
        [numberOfItemsToDisplay]="2"
        [maxNumOfRows]="2"
        [items]="messages">
    </rask-message-panel>
    }
    <div><span>{{content}}</span></div>
</div>
}
<div class="modal-footer">
    <rask-button aid="buttonYes" [disabled]="yesDisabled === true" color="primary"
        (click)="activeModal.close(saved)">{{yesCaption}}</rask-button>
    <rask-button aid="buttonNo" color="tertiary" (click)="activeModal.close(cancel)" id="cancel">{{noCaption}}
    </rask-button>
</div>